import * as React from "react";
import { SVGProps } from "react";
function SvgArrowLeftIconBold(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.146 1.146a.5.5 0 0 1 0 .708l-3.97 3.97a.25.25 0 0 0 0 .353l3.97 3.97a.5.5 0 0 1 0 .707l-.792.792a.5.5 0 0 1-.708 0L.354 6.354a.5.5 0 0 1 0-.708L5.646.354a.5.5 0 0 1 .708 0l.792.792Z"
        fill="#16A085"
      />
    </svg>
  );
}
export default SvgArrowLeftIconBold;
